import { render, staticRenderFns } from "./WholeGenomeSequencing.vue?vue&type=template&id=7297b9b4"
import script from "./WholeGenomeSequencing.vue?vue&type=script&lang=js"
export * from "./WholeGenomeSequencing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports